import { ReactNode } from 'react';
import { Tab } from 'semantic-ui-react';
import StandardizedLabels from './components/standardizedLabels';
import StandardizedLabelRelations from './components/standardizedLabelRelations';

function StandardizedLabelsPage() {
    const panes = [
        getPane('Standardized Labels', <StandardizedLabels />),
        getPane('Relations', <StandardizedLabelRelations />),
    ];
    return <Tab panes={panes} />;
}

function getPane(name: string, content: ReactNode) {
    return {
        menuItem: name,
        render: () => <Tab.Pane>{content}</Tab.Pane>,
    };
}

export default StandardizedLabelsPage;
